import { Alert, Button, Flex } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { getErrorMessage } from '@/core/utils/errors';

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}

export const ErrorState = ({
  error,
  onRetry,
  title = 'دریافت اطلاعات ناموفق بود',
}: ErrorStateProps): React.ReactElement => (
  <Flex vertical gap={12}>
    <Alert type="error" showIcon title={title} description={getErrorMessage(error)} />
    {onRetry ? (
      <Button icon={<ReloadOutlined />} onClick={onRetry} className="fit-content-button">
        تلاش دوباره
      </Button>
    ) : null}
  </Flex>
);
